import { Moon, Sun } from "lucide-react";
import { useTheme } from "../hooks/useTheme";

export default function ThemeToggle({ className = "", labelClassName = "hidden lg:inline" }) {
  const [theme, setTheme] = useTheme();
  const dark = theme === "dark";
  return (
    <button
      type="button"
      className={`px-3 py-2 rounded-xl border border-slate-200 dark:border-slate-700 text-slate-700 dark:text-slate-300 text-sm font-semibold hover:border-slate-300 dark:hover:border-slate-600 hover:bg-white dark:hover:bg-slate-900 transition focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-200 dark:focus-visible:ring-indigo-800/50 inline-flex items-center gap-2 ${className}`}
      aria-label="Alternar tema claro/escuro"
      onClick={() => setTheme(dark ? "light" : "dark")}
      title={dark ? "Mudar para claro" : "Mudar para escuro"}
    >
      {dark ? <Moon className="h-4 w-4" /> : <Sun className="h-4 w-4" />}
      <span className={labelClassName}>{dark ? "Escuro" : "Claro"}</span>
    </button>
  );
}
